import {Component, OnInit, inject} from '@angular/core';
import {PercentPipe} from '@angular/common';
import {MatChipsModule} from '@angular/material/chips';
import {ChangeIndicator, Direction} from '../../../models/change-indicator';
import {ShiftsCancelledService} from '../../../services/shifts-cancelled.service';

@Component({
  selector: 'app-shifts-cancelled-kpi',
  templateUrl: './shifts-cancelled-kpi.component.html',
  styleUrls: ['./shifts-cancelled-kpi.component.scss'],
  standalone: true,
  imports: [MatChipsModule, PercentPipe],
})
export class ShiftsCancelledKpiComponent implements OnInit {
  private shiftsCancelledService = inject(ShiftsCancelledService);

  improved: boolean = false;
  steady: boolean = false;
  worsened: boolean = false;

  changeIndicator: ChangeIndicator;

  ngOnInit() {
    this.shiftsCancelledService.mostRecentChangeIndicator$.subscribe(
      (changeIndicator) => {
        this.changeIndicator = changeIndicator;
        this.initDefaultChangeIndicators();
        switch (changeIndicator.direction) {
          case Direction.up:
            this.worsened = true;
            break;
          case Direction.steady:
            this.steady = true;
            break;
          case Direction.down:
            this.improved = true;
            break;
          case Direction.none:
            break;
          default:
            throw new Error(
              `no state is set for kpi change indicator ${changeIndicator.direction}`
            );
        }
      }
    );
  }

  private initDefaultChangeIndicators(): void {
    this.worsened = false;
    this.steady = false;
    this.improved = false;
  }
}
